import React from 'react'

export const File: React.FC = () => (
  <svg
    height="150"
    style={{ backgroundColor: '#333333' }}
    viewBox="0 0 150 150"
    width="150"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M82.8876 50.5H55.5555V100.5H94.4444V61.9818H82.8876V50.5Z" fill="white" />
    <path d="M82.8876 61.9818H94.4444L82.8876 50.5V61.9818Z" fill="#9A9A9A" />
  </svg>
)
